import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/modules/shared.module';
import { MomentModule } from 'ngx-moment';
import { DirectLinkService } from './directlink.service';
import { DirectLinkComponent } from './directlink.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
    imports: [
      SharedModule,
      RouterModule,
      NgxMaskDirective,
      MomentModule
    ],
    providers: [DirectLinkService, provideNgxMask()],
    declarations: [
      DirectLinkComponent
    ]
  })
  export class DirectLinkModule { }